/**
 * 商品概况模块接口列表
 */

import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const goodsmsg = {
  // POST/goods/brandPage PC----根据tenantId查询商品品牌类目信息-----ygt
  brandPage(params) {
    return axios.post(`${base.baseURL}goods/brandPage`, params)
  },
  // POST/goods/changeGoodsShelf PC----(批量)商品上架/下架信息-----ygt
  goodsShelf(goodShelf, ids) {
    return axios.post(`${base.baseURL}goods/changeGoodsShelf?goodShelf=${goodShelf }&ids=${ids }`);
  },
  //POST/goods/changePrice PC---商品调价------ygt
  goodsPrice(param) {
    return axios.post(`${base.baseURL}goods/changePrice`, param);
  },
  // POST/goods/changeDeviceGridPrice PC---商品同步调价到货道------ygt
  changeDeviceGridPrice(param) {
    return axios.post(`${base.baseURL}goods/changeDeviceGridPrice`, param);
  },
  //POST /goods/deletemediadata 删除媒体资源
  deletemediadata(param) {
    return axios.post(`${base.baseURL}goods/deletemediadata`, param);
  },
  //GET /goods/details/{id} 根据商品id查询商品详细信息
  gooddetails(id) {
    return axios.get(`${base.baseURL}goods/details/${id}`)
  },
  //POST /goods/goods 添加入库根据商品编码查找
  goodsGoods(param) {
    return axios.post(`${base.baseURL}goods/goods`, param)
  },
  //GET /goods/listGoods/{categoryId} 添加入库根据获取相关商品类目信息
  listGoods(categoryId) {
    return axios.get(`${base.baseURL}goods/listGoods/${categoryId}`)
  },
  //POST /goods/loadFile 媒体数据上传
  loadFile(file) {
    return axios.post(`${base.baseURL}goods/loadFile`,file)
  },
  //POST/goods/manufacturerPage PC----商品生产厂家信息-----ygt
  manufacturerPage(params) {
    return axios.post(`${base.baseURL}goods/manufacturerPage`, params)
  },
  //POST/goods/page PC---查询所有商品信息---ygt
  goodsPage(param) {
    return axios.post(`${base.baseURL}goods/page`, param);
  },
  //DELETE/goods/remove PC---(批量)删除商品信息------ygt
  goodsRemove(ids) {
    return axios.delete(`${base.baseURL}goods/remove?ids=${ids}`);
  },
  //POST/goods/save PC---添加/修改商品信息------ygt
  goodsSave(param) {
    return axios.post(`${base.baseURL}goods/save`, param);
  },
  // POST /goods/updateGoodsById PC---修改商品(非药品)信息------ygt
  updateGoodsById(param) {
    return axios.post(`${base.baseURL}goods/updateGoodsById`, param);
  },
  //POST/goods/update PC---(批量)商品开售/停售信息------ygt
  goodsUpdate(ids, status) {
    return axios.post(`${base.baseURL}goods/update?status=${status}&ids=${ids}`);
  },

  /**
   * goodsoutrecord(商品出库管理)Goods Out Record Controller
   */
  // POST/goodsoutrecord/page PC---分页查询商品出库信息记录---ygt
  pageSoutre(params) {
    return axios.post(`${base.baseURL}goodsoutrecord/page`,params)
  },
  // POST/goodsoutrecord/save PC---添加出库信息记录---ygt
  saveSoutre(params) {
    return axios.post(`${base.baseURL}goodsoutrecord/save`,
      params
    )
  },
  /*  goodsputrecord(商品入库管理)Goods Put Record Controller

  */
  
  // POST/goodsputrecord/page PC---分页查询商品入(退)库信息记录---ygt
  pageSputre(params) {
    return axios.post(`${base.baseURL}goodsputrecord/page`, params)
  },
 
  // POST/goodsputrecord/record PC---添加退库信息记录---ygt
  recordSputre(params) {
    return axios.post(`${base.baseURL}goodsputrecord/record`, params)
  },
  // GET/goods/goodsInFoAd/{name}安卓/PC---api--查询商品名称对应的商品信息---ygt
  goodsInFoAd(name) {
    return axios.get(`${base.baseURL}goods/goodsInFoAd/${name}`)
  },
  pageForName(name) {
    return axios.post(`${base.baseURL}goods/pageForName?name=${name}`)
  },
}
export default goodsmsg;



// WEBPACK FOOTER //
// ./src/network/goodsmsg.js